import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Label,
  Badge,
} from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import DatePicker from '../../../shared/components/form/DatePicker';
import DataTable from '../../../shared/components/DataTable';
import TextBox from '../../../shared/components/form/TextBox';
import validate from './validate';

class PeriodoForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleDeleteMateriaPeriodo: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.number,
    esSemestrePar: PropTypes.bool,
    activo: PropTypes.bool,
    aniosLectivos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    materias: PropTypes.arrayOf(PropTypes.shape({})),
    carreras: PropTypes.arrayOf(PropTypes.shape({})),
    history: PropTypes.shape({}).isRequired,
    anhoLectivo: PropTypes.shape({}),
  }

  static defaultProps = {
    id: 0,
    submitting: false,
    esSemestrePar: false,
    activo: false,
    materias: [],
    carreras: [],
    anhoLectivo: {},
  }


  constructor(props) {
    super(props);
    this.editMateriaPeriodo = this.editMateriaPeriodo.bind(this);
    this.deleteMateriaPeriodo = this.deleteMateriaPeriodo.bind(this);
    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      filters: { id: 20 },
      carreraId: 0,
    };
    this.columns = [
      // { key: 'codigo', name: 'Codigo', search: false },
      // { key: 'anho', name: 'Periodo', width: '85px' },
      {
        key: 'semestreNroOrden',
        name: 'Semestre',
        search: false,
        width: '120px',
        className: 'text-center',
        format: row => (
          <h5>
            <Badge
              key={`mat_${row.id}`}
              color={row.semestreNroOrden % 2 === 0 ? 'secondary' : 'primary'}
            >
              {` ${row.semestreNroOrden}º`}
            </Badge>
          </h5>
        ),
      },
      {
        key: 'materia',
        name: 'Materia',
        search: false,
        format: row => `${row.codigoMateria} - ${row.materia} - ${row.seccion}`,
      },
      {
        key: 'malla',
        name: 'Malla',
        search: false,
      },
      {
        key: 'profesores',
        name: 'Profesor(es)',
        format: row => row.profesores.map(m => (
          <div key={`prof_${row.id}_${m.id}`} style={{ display: 'flex' }}>
            <h5 key={`prof_${row.id}_${m.id}`}>
              <Badge
                key={`prof_${row.id}_${m.id}`}
                color={m.role === 'Asistente' ? 'secondary' : 'primary'}
              >
                {m.role === 'Asistente' ? 'Aux' : 'Enc'}
              </Badge>
            </h5>
            <span>: {m.nombre} {m.apellido}</span>
          </div>
        )),
      },
      {
        key: 'tieneHorario',
        name: 'Horario',
        search: false,
        className: 'text-center',
        width: '100px',
        format: row => (
          <h4>
            <Badge
              color={row.tieneHorario ? 'success' : 'warning'}
            >
              {row.tieneHorario ? 'Si' : 'No'}
            </Badge>
          </h4>
        ),
      },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar materia" />,
        callback: (materiaPeriodo) => {
          this.editMateriaPeriodo(materiaPeriodo);
        },
      },
      {
        key: 'delete',
        icon: <span className="fa fa-trash" title="Borrar materia" />,
        callback: (materiaPeriodo) => {
          this.deleteMateriaPeriodo(materiaPeriodo);
        },
      },
    ];
  }


  agregarOquitarMaterias = (periodo) => {
    if (periodo) {
      const { id, history } = this.props;
      history.push(`/pages/periodos/edit/${id}/materias`);
    }
  };


  editMateriaPeriodo = (materiaPeriodo) => {
    if (materiaPeriodo) {
      const { id, history } = this.props;
      history.push(`/pages/periodos/subjects/edit/${id}/${materiaPeriodo.id}`);
    }
  };

  deleteMateriaPeriodo = (materiaPeriodo) => {
    if (materiaPeriodo) {
      const { handleDeleteMateriaPeriodo } = this.props;
      handleDeleteMateriaPeriodo(materiaPeriodo);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateSubjectsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateSubjectsTable(1, pageSize, {});
  };

  onCarreraChanges = (carrera) => {
    this.setState({
      carreraId: carrera.value,
    });
  };

  filterMaterias = () => {
    const { materias } = this.props;
    const { carreraId } = this.state;

    return materias.filter(m => m.carreraId === carreraId || carreraId === 0);
  };

  getCarreras = () => {
    const { carreras } = this.props;
    return [
      ...[{ value: 0, label: 'Todas' }],
      ...carreras,
    ];
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  render() {
    const {
      id,
      submitting,
      handleSubmit,
      onBack,
      aniosLectivos,
      esSemestrePar,
      activo,
    } = this.props;

    const {
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
            <Form className="form" onSubmit={handleSubmit}>
              <Col md={12} lx={12}>
                <div className="card__title">
                  <h5 className="bold-text">Datos del periodo</h5>
                </div>
              </Col>
              <Col md={4} lx={8}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Nombre</span>
                  <div className="form__form-group-field">
                    <Field
                      name="nombre"
                      component={TextBox}
                      placeholder="Nombre"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col md={2} lx={4}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">A&ntilde;o lectivo</span>
                  <div className="form__form-group-field">
                    <Field
                      name="anhoLectivo"
                      component={renderSelectField}
                      placeholder="A&ntilde;o lectivo"
                      autoComplete="false"
                      options={aniosLectivos}
                    />
                  </div>
                </div>
              </Col>


              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label ">Semestre par?</span>
                  <div className="form__form-group-field">
                    <Field
                      name="esSemestrePar"
                      component={renderCheckBoxField}
                      label="Semestre par?"
                      value={esSemestrePar ? 'checked' : ''}
                      defaultChecked={esSemestrePar}
                    />
                  </div>
                </div>
              </Col>

              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label ">Activo?</span>
                  <div className="form__form-group-field">
                    <Field
                      name="activo"
                      component={renderCheckBoxField}
                      label="Activo?"
                      value={activo ? 'checked' : ''}
                      defaultChecked={activo}
                    />
                  </div>
                </div>
              </Col>

              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha de inicio de clases</span>
                  <div className="form__form-group-field">
                    <Field
                      name="inicioClases"
                      component={DatePicker}
                      placeholder="Fecha de inicio de clases"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Fecha de fin de clases</span>
                  <div className="form__form-group-field">
                    <Field
                      name="finClases"
                      component={DatePicker}
                      placeholder="Fecha de fin de clases"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Inicio de inscripciones</span>
                  <div className="form__form-group-field">
                    <Field
                      name="inicioPeriodoInscripcion"
                      component={DatePicker}
                      placeholder="Inicio de inscripciones"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Fin de inscripciones</span>
                  <div className="form__form-group-field">
                    <Field
                      name="finPeriodoInscripcion"
                      component={DatePicker}
                      placeholder="Fin de inscripciones"
                      autoComplete="false"
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Límite calificar tareas</span>
                  <div className="form__form-group-field">
                    <Field
                      name="finCalificarTareas"
                      component={DatePicker}
                      placeholder="Límite calificar tareas"
                      autoComplete="false"
                      showTimeInput="true"
                    />
                  </div>
                </div>

              </Col>
              <Col md={3} lx={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Límite editar planeamiento</span>
                  <div className="form__form-group-field">
                    <Field
                      name="finEditarPlaneamiento"
                      component={DatePicker}
                      placeholder="Límite editar planeamiento"
                      autoComplete="false"
                      showTimeInput="true"
                    />
                  </div>
                </div>

              </Col>
            </Form>
            <hr />
            {id && (
              <div className="table-wrapper">
                <Row>
                  <Col md={8} lg={4}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.agregarOquitarMaterias({ id })}
                    >
                      Agregar / Quitar Materias
                    </button>
                  </Col>
                  <Col md={8} lg={4}>
                    <FormGroup row>
                      <Label for="carrera" sm={2} className="form__form-group-label text-right">Carrera:</Label>
                      <Col sm={10}>
                        <Field
                          id="carrera"
                          name="carrera"
                          component={renderSelectField}
                          placeholder="Todas"
                          defaultValue={0}
                          autoComplete="false"
                          options={this.getCarreras()}
                          onChange={this.onCarreraChanges}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
                <DataTable
                  title="Detalle de materias"
                  columns={this.columns}
                  items={this.filterMaterias()}
                  onChangePage={this.onChangePage}
                  page={page}
                  pageSize={pageSize}
                  totalItemsCount={totalItemsCount}
                  getGridActions={key => this.getGridActions(key)}
                  onSubmit={this.onDataTableSubmit}
                  onClearFilters={this.onDataTableClearFilters}
                  initialValues={filters}
                  enableReinitialize
                />
              </div>
            )}
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxPeriodoForm = reduxForm({
  form: 'PeriodoForm',
  validate,
  enableReinitialize: true,
})(PeriodoForm);

export default setPropsAsInitialValues(ReduxPeriodoForm);
